import { update } from 'lodash';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import UserSelectTableEditCellPopover from './UserSelectTableEditCellPopover';
import { usePopper } from 'react-popper';
import usePortal from 'react-useportal';
import { Field, FieldSelect } from '../../../../data/types';
interface UserSelectTableEditCellProps {
    field: Field;
  onChange: (newValue: string | undefined | any) => void;
  internalValue: string | undefined | any;
  displayValue: string | undefined | any;
  stopEditing: Function;
}

export const UserSelectTableEditCell = ({ field, onChange, internalValue, displayValue, stopEditing }: UserSelectTableEditCellProps) => {
  const [referenceElement, setReferenceElement] = useState<any>(null);
  const [popperElement, setPopperElement] = useState<any>(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    strategy: 'fixed',
    placement: 'bottom-start',
    modifiers: [
      {
        name: 'flip',
        options: {
          fallbackPlacements: ['top-start'],
        },
      },
    ],
  });
  const { Portal } = usePortal({ closeOnOutsideClick: false });
  return (
    <>
      <div ref={setReferenceElement} className="w-100 h-100 d-flex flex-row align-items-center">{internalValue}</div>
      <Portal>
        <div ref={setPopperElement} style={styles.popper} {...attributes.popper}>
          <UserSelectTableEditCellPopover stopEditing={stopEditing} field={field as FieldSelect} onChange={onChange} internalValue={internalValue} />
        </div>
      </Portal>
    </>
  );
};

export default UserSelectTableEditCell;
